import { render, staticRenderFns } from "./ItemPrices.vue?vue&type=template&id=4139fe2b&"
import script from "./ItemPrices.vue?vue&type=script&lang=js&"
export * from "./ItemPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports